<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.payment.setup.feeGroup.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.payment.setup.feeGroup.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'fee-group-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div style="width: 25%;">
            <div class="d-flex justify-content-between">
              <select class="form-control mr-2">
                <option value>{{ $t('feegroup.branch') }}</option>
              </select>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'payment_term'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.branch.branch_name_en }}</td>
          <td>{{ record.fee_group_name }}</td>
          <td class="text-center">{{ record.fee_amount }}</td>
          <td class="kh-font text-center">
            <a
              href="#"
              title="Edit"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              title="Delete"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'feeGroup',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('feeGroup', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.feeGroup.search
      },
      set(newValue) {
        this.$store.commit('feeGroup/SET_SEARCH', newValue)
        this.$store.commit('feeGroup/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('school.payment.setup.feeGroup.branch'),
          style: 'width: 15%;'
        },
        { name: this.$t('school.payment.setup.feeGroup.groupName') },
        {
          name: this.$t('school.payment.setup.feeGroup.amount'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('administration.mobile_feature.news.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('feeGroup/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('feeGroup/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'fee-group-edit',
        params: { id: record.fee_group_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('feeGroup/destroy', record.fee_group_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
